var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideBarCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0CAF6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1103 11L6.19029 15.92C6.13014 15.9776 6.08227 16.0468 6.04956 16.1234C6.01686 16.2 6 16.2824 6 16.3657C6 16.449 6.01686 16.5314 6.04956 16.608C6.08227 16.6846 6.13014 16.7538 6.19029 16.8114L11.1103 21.7314",
    fill: "#0CAF6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1103 11L6.19029 15.92C6.13014 15.9776 6.08227 16.0468 6.04956 16.1234C6.01686 16.2 6 16.2824 6 16.3657C6 16.449 6.01686 16.5314 6.04956 16.608C6.08227 16.6846 6.13014 16.7538 6.19029 16.8114L11.1103 21.7314",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1797 11L25.0997 15.92C25.1598 15.9776 25.2077 16.0468 25.2404 16.1234C25.2731 16.2 25.29 16.2824 25.29 16.3657C25.29 16.449 25.2731 16.5314 25.2404 16.608C25.2077 16.6846 25.1598 16.7538 25.0997 16.8114L20.1797 21.7314",
    fill: "#0CAF6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1797 11L25.0997 15.92C25.1598 15.9776 25.2077 16.0468 25.2404 16.1234C25.2731 16.2 25.29 16.2824 25.29 16.3657C25.29 16.449 25.2731 16.5314 25.2404 16.608C25.2077 16.6846 25.1598 16.7538 25.0997 16.8114L20.1797 21.7314",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarCloseButton);
export default __webpack_public_path__ + "static/media/SideBarCloseButton.333921f054f074ce347cd6522e164f82.svg";
export { ForwardRef as ReactComponent };